
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightsLeetColour as ObiLightsLeetColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lights-leet-colour.js';
 
 
 

 
 export const ObiLightsLeetColour = createComponent({
   react: React,
   tagName: 'obi-lights-leet-colour',
   elementClass: ObiLightsLeetColourElement,
   events: {
     
   }
  });
 
 